import React from 'react';
import translate from '../utilities/translator';

export default function TutorialMessage({
  message,
  onHideClick,
  show,
  buttonType = 'default',
  className = '',
}) {
  return (
    <div className="c-row">
      <div className="col-lg-12">
        <div className={`l-tutorial-message${!show ? ' hidden' : ''} ${className}`}>
          <div className="tm-lft">
            <i className="tm-ico" />
            <span className="tm-txt">{message}</span>
          </div>
          {buttonType === 'default' && (
            <span className="tm-btn" onClick={onHideClick}>{translate('holidayFinder.app.gotTtThanks')}</span>
          )}

          {buttonType === 'small' && (
            <button className="icon-close" onClick={onHideClick} />
          )}
        </div>
      </div>
    </div>
  );
}
